<template>
  <Seals
    :image="image"
    :image-title="sealsProps.imageTitle"
    :alt="sealsProps.alt"
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import Seals from './Seals.vue';
import { SealsBuilder, WrapperProps } from './Seals.model';
import { magnoliaGetters } from '~/composables/getters';

const props = defineProps(WrapperProps);
const { $domain } = useNuxtApp();

const sealsProps = computed(() => SealsBuilder.build(props));

const image = computed(() => ({
  src: magnoliaGetters.getDefaultSrcAsset(sealsProps.value.image, $domain.cmsAssetDomainPath),
  srcSet: magnoliaGetters.getSrcSetImagesAsString(sealsProps.value.image, $domain.cmsAssetDomainPath, sealsProps.value.aspectRatio, sealsProps.value.mobileAspectRatio?.[0]?.aspectRatio),
}));
</script>
